import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthentService } from './authent.service';

@Injectable({
  providedIn: 'root'
})
export class StatePersistService {

  constructor(
    private authentService: AuthentService,
    private router: Router,
  ) { }

  public get(urlString: string){
    var routerString = "";
    var result = null;
    if(this.router.url.indexOf("?")>0){
      routerString = this.router.url.substr(0, this.router.url.indexOf("?"));
    } else {
      routerString = this.router.url;
    }
    var actualUser = this.authentService.currentUser().USERGUID;
    if(JSON.parse(localStorage.getItem("GridFilterSettings")) != null){
      var tableSettings = JSON.parse(localStorage.getItem("GridFilterSettings"));
      if(tableSettings[actualUser] != undefined){
        tableSettings[actualUser].forEach(element => {
          if(element.routerString == routerString && element.urlString == urlString){
            result = element.gridFilters;
          }
        });
      }
    }
    return result;
    // const settings = localStorage.getItem(`${token} - ${componentName}`);
    // return settings ? JSON.parse(settings) : settings;
  }

  public set(gridConfig: any, urlString: string): void {
    var routerString = "";
    var result = null;
    if(this.router.url.indexOf("?")>0){
      routerString = this.router.url.substr(0, this.router.url.indexOf("?"));
    } else {
      routerString = this.router.url;
    }
    var actualUser = this.authentService.currentUser().USERGUID;
    var tableSettings;
    if(JSON.parse(localStorage.getItem("GridFilterSettings")) != null){
      tableSettings = JSON.parse(localStorage.getItem("GridFilterSettings"));
    } else {
      tableSettings = new Object();
    }
    if(tableSettings[actualUser] == undefined){
      tableSettings[actualUser] = new Array();
    }
    var object = {
      routerString: routerString,
      urlString: urlString,
      gridFilters: gridConfig,
    }
    tableSettings[actualUser].forEach(element => {
      if(element.routerString == object.routerString && element.urlString == object.urlString){
        tableSettings[actualUser].splice(tableSettings[actualUser].indexOf(element),1);
      }
    });
    tableSettings[actualUser].push(object);
    localStorage.setItem("GridFilterSettings", JSON.stringify(tableSettings))
  }
}